import React from "react";
import "../css/privacy.scss";
import PolicyPage from "./PolicyPage";

function CookiePolicy() {
  return (
    <PolicyPage title="Cookie & Local Storage Policy">
      <p><em>Last updated: October 16, 2026</em></p>
      <p>Cookies are small files that a website asks a browser to store. Local storage is a related browser feature that keeps data on your device without sending it automatically with every page request. This page describes the current danecay storefront.</p>
      <h2>Cart Local Storage</h2>
      <p>The store currently uses local storage to remember product identifiers, selected options and quantities in your cart. This is necessary to preserve the cart while you move between pages or return using the same browser.</p>
      <h2>Hosting and Security</h2>
      <p>Hosting, network or security providers may use strictly necessary cookies or logs to deliver pages, balance traffic, prevent abuse and protect transactions. These technologies are used for service operation rather than advertising.</p>
      <h2>No Current Advertising or Analytics Cookies</h2>
      <p>The current storefront does not install advertising pixels or analytics cookies. If optional analytics or advertising technology is added later, this policy and any legally required consent controls will be updated before that use begins.</p>
      <h2>Payment Provider</h2>
      <p>After you choose Pay Now, you leave this storefront for the payment provider. That provider may use its own essential, security or preference technologies under its own privacy and cookie notices.</p>
      <h2>Managing Browser Data</h2>
      <p>You can clear local storage and cookies in browser settings. Clearing danecay local storage removes the saved cart. Blocking necessary provider cookies may prevent payment or security functions from working. Questions can be sent to <a href="mailto:core@danecay.shop">core@danecay.shop</a>.</p>
    </PolicyPage>
  );
}

export default CookiePolicy;
